export default {
    abs: "mut.",
    activate: "Faollashtirish",
    add_category: "Toifa qo‘shish",
    add_kit: "To'plam qo'shing",
    additional_materials: "Qo‘shimcha materiallar",
    archive: "Arxiv",
    are_you_sure_you_want_to_delete_category: "Haqiqatan ham toifani o‘chirib tashlamoqchimisiz?",
    are_you_sure_you_want_to_delete_service: "Haqiqatan ham xizmatni o‘chirib tashlamoqchimisiz?",
    assistant_reward: "Yordamchining ish haqi",
    average_price: "O‘rtacha narxi",
    categories: "Toifalar",
    category: "Toifa",
    change_category: "Toifani o‘zgartirish",
    change_pricelist: "Pricelistni o‘zgartirish",
    classificator_code: "Klassifikator kodi",
    classificator_title: "Klassifikator nomi",
    complex_service: "Kompleks xizmat",
    complex_services: "Kompleks xizmatlar",
    curator_reward: "Kuratorning ish haqi",
    current_value: "Joriy qiymati",
    deactivate: "Deaktivlashtirish",
    decrease_price: "Narxni kamaytirish",
    discounted_price: "Chegirma narxi",
    do_not_accrue_bonus: "Bonus hisoblanmasin",
    doctor_reward: "Shifokor mukofoti",
    fill_from_previous_visits: "Oldingi tashriflardan to'ldiring",
    fixed_materials_expense_sum: "Materiallar xarajatlari summasi",
    import_standard_services: "Standart xizmatlar importi",
    increase_price: "Narxni oshirish",
    individual_bonus: "Bemor uchun shaxsiy bonus (%)",
    make_separate: "Uni alohida qiling",
    manager: "Administrator",
    manager_reward: "Administrator mukofoti",
    mkb_10_diagnosis: "ICD 10 ga muvofiq diagnostika",
    money_lost_on_discount: "Chegirmalardan pul yo'qotish",
    move_to_group: "Guruhga o'tish",
    ndfl_code: "Kod NDFL",
    not_selected: "Belgilanmagan",
    packages_cost: "To‘plamlarning tannarxi",
    personal_percent_for_assistant: "Yordamchi uchun shaxsiy foiz",
    personal_percent_for_curator: "Kurator uchun shaxsiy foiz",
    personal_percent_for_doctor: "Shifokor uchun shaxsiy foiz",
    personal_percent_for_manager: "Administrator uchun shaxsiy foiz",
    personal_percent_for_technic: "Texnik uchun shaxsiy foiz",
    price_can_be_changed: "Davolash kartochkasida narx o‘zgarishi mumkin",
    price_from: "Narxdan",
    pricelist_price: "Narxiga qarab narx",
    pricelist_short: "Prays",
    reset_selection: "Tanlovni tiklash",
    send_to_archive: "Arxivga yuborish",
    Service: "Xizmat",
    service_category: "Toifa",
    service_code: "Xizmat kodi",
    services_not_selected: "Hech qanday xizmat tanlanmagan",
    technic: "Texnik",
    technic_reward: "Texnik mukofoti",
    teeth_not_selected: "Hech qanday tish tanlanmagan",
    use_visit_anamnez: "Tashrif tarixidan foydalaning",
    visit_status: "Statusga tashrif buyurish"
}
